$(function(){
  $('.menu-drawer-container').on('click',function(){
    if(!$('.header-wrapper').hasClass('fixed')) {
      $('.header-wrapper').addClass('fixed');
    }
  });

  $('.accordion-ttl').on('click',function(){
    var text = $(this).children('small').text();
    $(this).toggleClass('open');
    $(this).next('.accordion-contents').slideToggle();
    if(text == 'open') {
      $(this).children('small').text('close');
    }
    else if(text == 'close') {
      $(this).children('small').text('open');
    };
  });

    
  // smooth scroll ------------------------------------
  $('a[href^="#"]').click(function(){
    let speed = 500;
    let href= $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
  
  
  // link blank ---------------------------------------------
  const links = document.querySelectorAll('a');
  for (let i = 0; i < links.length; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

  // scroll anime ------------------------------
  $('.anime').each(function(){
    var elemTop = $(this).offset().top;
    var windowHeight = elemTop - $(window).height();
    if ($(window).scrollTop() > windowHeight){
      if(!$(this).hasClass('active')) {
        $(this).addClass('active');
      };
    };
  });
  $(window).scroll(function(){ 
    var scroll = $(window).scrollTop();
    $('.anime').each(function(){
      var elemTop = $(this).offset().top + 100;
      var windowHeight = $(window).height();
      if (scroll + windowHeight > elemTop){
        if(!$(this).hasClass('active')) {
          $(this).addClass('active');
        };
      };
    });
  });
});



// ProvinceCode変換--------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {
  var isoToPrefecture = { // ISOコードと都道府県の対応表
    'JP-01': '北海道', 'JP-02': '青森県', 'JP-03': '岩手県',
    'JP-04': '宮城県', 'JP-05': '秋田県', 'JP-06': '山形県', 'JP-07': '福島県',
    'JP-08': '茨城県', 'JP-09': '栃木県', 'JP-10': '群馬県', 'JP-11': '埼玉県',
    'JP-12': '千葉県', 'JP-13': '東京都', 'JP-14': '神奈川県', 'JP-15': '新潟県',
    'JP-16': '富山県', 'JP-17': '石川県', 'JP-18': '福井県', 'JP-19': '山梨県',
    'JP-20': '長野県', 'JP-21': '岐阜県', 'JP-22': '静岡県', 'JP-23': '愛知県',
    'JP-24': '三重県', 'JP-25': '滋賀県', 'JP-26': '京都府', 'JP-27': '大阪府',
    'JP-28': '兵庫県', 'JP-29': '奈良県', 'JP-30': '和歌山県', 'JP-31': '鳥取県',
    'JP-32': '島根県', 'JP-33': '岡山県', 'JP-34': '広島県', 'JP-35': '山口県',
    'JP-36': '徳島県', 'JP-37': '香川県', 'JP-38': '愛媛県', 'JP-39': '高知県',
    'JP-40': '福岡県', 'JP-41': '佐賀県', 'JP-42': '長崎県', 'JP-43': '熊本県',
    'JP-44': '大分県', 'JP-45': '宮崎県', 'JP-46': '鹿児島県','JP-47': '沖縄県'
  };

  // 都道府県コードを含む要素を取得
  var prefectureElements = document.querySelectorAll('.jp_province_code');

  // 要素のそれぞれに対して、ISOコードを都道府県名に変換する
  prefectureElements.forEach(function(element) {
    var prefectureCode = element.innerText;
    var japaneseName = isoToPrefecture[prefectureCode];

    if (japaneseName) {
      element.innerText = japaneseName;
    }
  });
});